"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Location = void 0;
const common_1 = require("../../common");
class Location extends common_1.MongoDocument {
}
exports.Location = Location;
//# sourceMappingURL=location.model.js.map